<template>
    <div class="bg">
        <a-row class="container" type="flex" justify="center" align="middle">
            <a-col :span="12">
                <a-form-model ref="dynamicValidateForm"
                            :model="form"
                            :rules="rules"
                            :label-col="labelCol"
                            class="form-warp">
                    <div>
                        <img class="containerImg" :src="require(`../../../static/images/loginimg.png`)" alt="">
                    </div>
                    <a-form-model-item class="inputForm" prop="username" ref="username">
                        <div class="inputWrap">
                            <span class="inputSpan"><a-icon type="user" />&nbsp;用户名：</span>
                            <a-input class="inputStyle" v-model="form.username" @blur="() => {$refs.username.onFieldBlur()}"/>
                        </div>
                    </a-form-model-item>
                    <a-form-model-item class="inputForm" prop="password" ref="password">
                        <div class="inputWrap">
                            <span class="inputSpan"><a-icon type="unlock" />&nbsp;密码：</span>
                            <a-input class="inputStyle" type="password" v-model="form.password" @blur="() => {$refs.password.onFieldBlur()}"/>
                        </div>
                    </a-form-model-item>
                    <a-form-model-item prop="code" ref="code">
                        <div class="imageURLWrap">
                            <div class="imageURL">
                                <a-input class="imageURLInput" placeholder="验证码" type="text" v-model="form.code" />
                            </div>
                            <img @click="getCheckCode" :src="imageURL" alt="">
                        </div>
                    </a-form-model-item>
                    <a-form-model-item style="margin: auto;width: 350px;text-align: center;line-height: 40px;overflow: hidden;">
                        <a-button style="line-height: 40px;height: 40px;" block type="primary" html-type="submit" @click="submitForm('dynamicValidateForm')">
                            登录
                        </a-button>
                    </a-form-model-item>
                </a-form-model>
            </a-col>
        </a-row>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        components: {},
        data () {
            return {
                labelCol: {span: 6},
                wrapperCol: {span: 14},
                form: {
                    username: '',
                    password: '',
                    code: '',
                },
                rules: {
                    username: [
                        {required: true, message: '请输入账号', trigger: 'blur'},
                    ],
                    password: [
                        {required: true, message: '请输入密码', trigger: 'blur'},
                    ],
                    code: [
                        {required: true, len:4, message: '验证码错误', trigger: 'blur'},
                    ]
                },
                imageURL:'',
                imageCheckURL:''
            }
        },
        mounted(){
            // $.get(gatewayHost + "/captcha/imageUrl", function (res) {
            //     if (res.status == 0) {
            //         var imageURL = res.data.imageURL;
            //         imageCheckURL = res.data.imageCheckURL;
            //         $("#validateImg").attr("src", imageURL);
            //     }
            // });
            this.getCheckCode();
        },
        created () {

        },
        methods: {
            getCheckCode(){
                let that = this;
                axios.get(this.apis.user.imageUrl, {}, false).then((res) => {
                    console.log(res);
                    if (res.data.status == 0) {
                        that.imageURL = res.data.data.imageURL;
                        that.imageCheckURL = res.data.data.imageCheckURL;
                    } else {
                        that.$message.error('请求失败');
                    }
                }).catch((err) => {
                    that.$message.error('请求失败');
                });
            },
            submitForm(formusername) {
                this.$refs[formusername].validate(valid => {
                    if (valid) {
//                        alert('submit!');
                        this.loginFromServer();
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            loginFromServer() {
                //请求登入接口
                // $.get(this.imageCheckURL + "?t=" + new Date().getTime(), {imageCode: checkCode}, function (res) {
                axios.get(this.imageCheckURL + "?imageCode="+this.form.code+"&t=" + new Date().getTime(), {imageCode: this.form.code}, false).then(res => {
                    // console.log(res.data);
                    if (res.data.status == 0) {
                        let data = this.form;
                        data["grant_type"] = 'password';
                        data["client_id"] = 'resourceclient';
                        data["client_secret"] = 'resourcesecret';
                        data["app_id"] = 'APPY042';
                        this.http.postForm(this.apis.user.login, data).then(res => {
                            if(res.status === 0){
                                this.appUtils.setLocalStorage(this.constStatic.TOKEN_KEY, res.access_token);
                                this.appUtils.setLocalStorage(this.constStatic.USER_INFO, res);
                                this.http.get(this.apis.user.checkGroupLeader+'/'+res.x_userId).then(res => {
                                    if (res.status == 0){
                                        this.$router.replace({
                                            path: '/home'
                                        });
                                    } else {
                                        localStorage.removeItem(this.constStatic.TOKEN_KEY);
                                        localStorage.removeItem(this.constStatic.USER_INFO);
                                        this.$message.error(res.message);
                                    }
                                }).catch(err => {
                                    // console.log(err);
                                    if (err.status == 0){
                                        this.$router.replace({
                                            path: '/home'
                                        });
                                    } else {
                                        localStorage.removeItem(this.constStatic.TOKEN_KEY);
                                        localStorage.removeItem(this.constStatic.USER_INFO);
                                        this.$message.error(err.message);
                                    }
                                })
                            }else if(res.status === 1){
                                this.$message.error(res.message);
                            }

                        }).catch(err => {
                            this.$message.error('请求失败');
                        })
                    } else {
                        this.$message.error(res.message);
                        this.getCheckCode();
                    }
                })
                
            }
        }
    }
</script>

<style lang="less" scoped>
    .bg{
        background: url('../../../static/images/loginbg.png') no-repeat;
        background-color: rgba(220, 238, 255, 0.25);
        background-size: 100%;
        background-position: center;
    }
    .imageURLWrap{
        width: 350px;
        margin: auto;
        .imageURL{
            display: inline-block;
            width: 70%;
            background-color: white;
            border: 1px solid #D9D9D9;
            border-radius: 4px;
            white-space: nowrap;
            .imageURLInput{
                width: 100%;
                border: none;
            }
            .inputSpan{
                display: inline-block;
                width: 16%;
                text-align: left;
                padding: 0 15px;
            }
        }
        img{
            float: right;
            width: calc(100% - 72%);
            height: 40px;
        }
    }
    .container {
        height: 100vh;
        text-align: left;
        .containerImg{
            width: 350px;
            height: 70px;
            display: block;
            margin: 20px auto;
        }
        .form-warp {
            .form-title {
                padding: 10px 0;
                text-align: center;
                font-size: 24px;
                font-weight: bold;
            }
            .inputWrap{
                width: 350px;
                margin: auto;
                border: 1px solid #D9D9D9;
                border-radius: 4px;
                background-color: white;
                white-space: nowrap;
                .inputSpan{
                    display: inline-block;
                    // width: 16%;
                    text-align: left;
                    padding: 0 6px 0 15px;
                }
                .inputStyle{
                    display: inline-block;
                    width: 70%;
                    border: none;
                }
            }
            // background-color: white;
            padding: 40px 0;
            border-radius: 5px;
        }
    }
    .inputForm{
        width: 360px;
        margin-left: auto;
        margin-right: auto;
    }
</style>
